import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import RatingStars from "@components/ui/RatingStars";
import ApiProxy from "@ts/ApiProxy";
import GS from "@ts/GlobalSetting";
import ProductNav from "./ProductNav";
import { Product } from "./ProductTypes";
import ReviewRating from "./ReviewRating";
import Tools from "@root/ts/Tools";

export default class ReviewOverview extends ComponentBase
{
  finalRating: number = 0;
  finalRatingString: string = "0.0";

  constructor(elem: ComponentElem)
  {
    super(elem);    
    
    let pageData: Product.PageData = ApiProxy.getPageData();

    let $ratings = this.$root.find('[component="review-rating"]'),
      maxValue: number = GS.reviewMaxRating,
      totalScore = 0;

    $.each($ratings, (index:number, el: ComponentElem)=>
    {
      let score = Tools.parseFloat(pageData.review_overview.score[index].value);
      totalScore += score;
      
      ReviewRating.generate(el, pageData.review_overview.score[index]);
    });

    this.finalRating = totalScore / $ratings.length,
    this.finalRatingString = pageData.review_overview.average_score = Tools.parseFloat(String(this.finalRating)).toFixed(1);    
      
    let percent = this.finalRating / maxValue;
    this.$root.find(".score > .value").text(this.finalRatingString);
    this.$root.find(".max-value").text(maxValue);
    this.$root.find(".num-comments").text(pageData.review_overview.total_count);

    // (this.$root.find(`[component="rating-stars"]`)[0] as ComponentElem)._component.setValue(percent);
    // this.$root.find(".stars > .value").css("width", (100*percent) + "%");

    let ratingStarsElem: ComponentElem = this.$root.find(`[component="rating-stars"]`)[0] as ComponentElem,
    ratingStars: RatingStars = new RatingStars(ratingStarsElem);
    ratingStars.setValue(percent);

    this.$root.find(".to-comment").on("click", (event:Event)=>
    {
      event.preventDefault();
      
      ProductNav.to("#product-reviews");
    });
  }
}